import styled from "styled-components";

const Position = styled.h2`
  color: ${props => props.theme.colors.black};
  font-weight: 800;
  font-size: 1.6rem;
  margin: 0;
`;

export default Position;
